<template>
  <div class="page my-tickets">
    <header>
      <div @click="back" tabindex="0" @keypress.space="back" class="back-btn"><i class="fa fa-fw fa-chevron-left"></i></div>
      <div class="view-title">{{ 'MyTickets' | lang }}</div>
      <!-- <button @click="showFilters"><i class="fa fa-fw fa-filter"></i></button> -->
    </header>
    <div v-if="dwMyTicketsExtended.length">
      <!-- <ul class="filters">
        <li>
          <select v-model="filters.validated" v-bind:value="filters.validated">
            <option v-for="(opt, idx) in boolOptions" :key="idx" :value="opt">{{opt | lang}}</option>
          </select>
          <span>{{ 'validated' | lang }}: {{(filters.validated || dictValueALL) | lang}}</span>
        </li>
        <li @click="changeFilterName">
          <button @click.stop="filters.name = null" :disabled="!filters.name"><i class="fa fa-fw fa-close"></i></button><span>{{ 'Name' | lang }}: {{filters.name || dictValueALL}}</span>
        </li>
      </ul> -->
      <div class="form-grid-1-2">
        <div class="floating-label">
          <select v-model="filters.validated" v-bind:value="filters.validated" placeholder=" ">
            <option v-for="(opt, idx) in boolOptions" :key="idx" :value="opt">{{opt | lang}}</option>
          </select>
          <label>{{ 'validated' | lang }}</label>
        </div>
        <div class="floating-label">
          <input v-model="filters.name" placeholder=" " />
          <label>{{ 'Name' | lang }}</label>
        </div>
      </div>
      <transition-group :name="transitionname" tag="ul" class="nav">
        <li @click="openTicket(t)" v-for="t in filtered" :key="t.id" :tid="t.id">
          <div style="width:100%">
            <div class="main">{{t.itemLabel}}</div>
            <div class="sub">{{t.itemDescriptions}}</div>
            <div class="sub space-between"><span>{{ 'BoughtDate' | lang }} {{t.addedDateTime | datetime}}</span><span>{{(t.amount/100) | currency}}&nbsp;</span></div>
          </div>
          <div v-if="editing" @click.stop>
            <button @click="deleteElementAtIndex(t)" v-if="deleting === t.id"><i class="fa fa-fw fa-check"></i></button>
            <button @click="deleting = t.id" v-else :disabled="!t.validated"><i class="fa fa-fw fa-trash"></i></button>
          </div>
          <div v-else>
            <i class="fa fa-fw fa-check double-check" v-if="t.validated" :class="{ 'first-check': t.validated, 'second-check': t.vadValidated}"></i>
            <!-- <span v-if="t.validated" class="double-fa-check">
              <i class="fa fa-fw fa-check" v-if="t.vadValidated"></i>
              <i class="fa fa-fw fa-check" v-if="t.userValidated"></i>
            </span> -->
            <i class="fa fa-fw fa-chevron-right" v-else></i>
          </div>
        </li>
      <!--</ul>--></transition-group>
    </div>
    <div v-else>
      <div class="flexcentered bigger">{{ 'NoTicketsMessage' | lang }}<span class="asLink" @click="goToBuyNewTicketsIfConnected">"{{ 'BuyMenu' | lang }}"</span></div>
    </div>
    <footer>
      <span>&nbsp;</span>
      <button @click="editing = true" v-if="somethingDeletable && !editing">
        <i class="fa fa-fw fa-trash"></i>
      </button>
      <button @click="editing = false" v-if="editing">
        {{ 'done' | lang }}
      </button>
    </footer>
  </div>
</template>

<script>
/* eslint-disable brace-style */
import page from '@/mixins/routeControl'
import databaseWrapperMixin from '@/mixins/databaseWrapperMixin'
import moment from 'moment'
// import SimpleDialog from '@/dialogs/SimpleDialog'
// import { create } from 'vue-modal-dialogs'
import eticketServices from '@/mixins/services/eticketsServices'

moment.locale('en')
// const simpleDialogCreator = create(SimpleDialog)

export default {
  name: 'MyTickets',
  mixins: [ page, databaseWrapperMixin, eticketServices ],
  data () {
    return {
      transitionname: '_',
      reads: [],
      editing: false,
      deleting: null,
      filters: {
        name: null,
        validated: 'no'
      }
    }
  },
  computed: {
    dwMyTicketsExtended () {
      let lst = this.dwMyTickets.map(t => {
        let now = moment()
        let then = moment(t.addedDateTime)
        let thenFormattedDate = then.format('DD/MM/YYYY')

        if (now.diff(then, 'hours') > now.hours() + 24) {
          then = thenFormattedDate
        } /* else if (now.diff(then, 'hours') > 23) {
          then = 'Yesterday at ' + then.format('HH:mm')
        } */ else {
          then = then.fromNow()
        }

        return { ...t, boughtAt: then, validated: t.vadValidated || t.userValidated, thenFormattedDate, description: t.itemDescriptions + ' ' + t.itemLabel + ' ' + t.itemProductLabel }
      })
      lst.sort((a,b) => a.addedDateTime < b.addedDateTime ? 1 : -1)
      return lst
    },
    filtered () {
      let lst = this.dwMyTicketsExtended.slice()
      if (this.filters.name) {
        let fn = this.filters.name.toLowerCase()
        lst = lst.filter(l => l.description && l.description.toLowerCase().indexOf(fn) > -1)
      }
      if (this.filters.validated !== 'ALLM') {
        lst = lst.filter(l => l.validated === (this.filters.validated === 'Yes'))
      }
      return lst
    },
    /* fromOptions () {
      let lst = [...new Set(this.dwMyTicketsExtended.filter(t => !!t.origin).map(t => t.origin))]
      lst.sort()
      return [this.dictValueALL].concat(lst)
    },
    toOptions () {
      let lst = [...new Set(this.dwMyTicketsExtended.filter(t => !!t.destination).map(t => t.destination))]
      lst.sort()
      return [this.dictValueALL].concat(lst)
    }, */
    boolOptions () {
      return ['ALLM', 'Yes', 'no']
    },
    somethingDeletable () {
      return !!this.filtered.find(ticket => ticket.validated)
    }
  },
  methods: {
    goToBuyNewTicketsIfConnected () {
      if (this.isConnected) {
        this.goTo('/producttypes', true)
      } else {
        this.internalBus.$emit('notify:error', {
          text: this.dictValue('NoNetwork'),
          key: this.notifierKey
        })
      }
    },
    /* async changeFilterName () {
      let newName = await simpleDialogCreator({ text: this.dictValue('filterBy', { what: this.dictValue('name') }), okLabel: this.dictValue('Confirm'), cancelLabel: this.dictValue('Cancel'), input: { label: this.dictValue('Name'), value: this.filters.name } })
      if (newName !== false) {
        this.filters.name = newName.trim()
      }
    }, */
    deleteElementAtIndex (ticket) {
      this._deleteEticket(ticket.id).then(() => {
        this.dwDeleteTicket(ticket.id)
        this.deleting = null
        this.internalBus.$emit('notify:success', {
          text: this.dictValue('EticketDeleted'),
          key: this.notifierKey
        })
      }).catch(err => {
        console.warn(err)
        this.internalBus.$emit('notify:error', {
          text: this.dictValue('errorOccured') + (err.status === 418 ? '[VAD]' : ''),
          key: this.notifierKey
        })
      })
    },
    openTicket(t) {
      // TODO: ricordarsi la posizione di scroll e ripristinarla al back
      let page = document.querySelector('.page header + div, .page div.noheader')
      localStorage.setItem('mytickets_scroll', page.scrollTop)
      this.goTo('/mytickets/' + t.id)
    },
  },
  async mounted () {
    setTimeout(() => {
      this.transitionname = 'lsttransition'
    }, 1000)
    // this.filters.used = this.dictValueALL
    // this.filters.from = this.dictValueALL
    // this.filters.to = this.dictValueALL
    try {
      let ffs = localStorage.getItem('my_tickets_filter')
      if (ffs) {
        let ff = JSON.parse(ffs)
        this.filters.validated = ff.validated
      }
    } catch (e) {
      console.warn(e)
    }

    /* if (this.isFullLogged) {
      this._getEtickets().then(tickets => {
        this.dwReplaceUserTickets(tickets)
        this.$nextTick(() => {
          this.internalBus.$emit('updateEticketVadValidations', this.dwMyTickets.filter(eticket => !eticket.userCode).map(eticket => eticket.id))
        })
      }).catch(err => {
        console.warn(err)
        this.internalBus.$emit('notify:warn', {
          text: this.dictValue('CantUpdateETickets') + (err.status === 418 ? '[VAD]' : ''),
          key: this.notifierKey
        })
      })
    } else {
      try {
        await this.ensureAnonymousLogin()
        this.internalBus.$emit('updateEticketVadValidations', this.dwMyTickets.map(eticket => eticket.id))
      } catch(e) {
        // nada
      }
    }
    if (this.isLogged) {
      this.dwUserValidatedTicketsTemp.slice().forEach(async el => {
        try {
          await this._userValidateEticket(el.id, el.value)
          this.dwRemovePendingUserValidation(el.id)
        } catch (e) {
          console.warn(e)
        }
      })
    } else {
      console.log('Retarded validation skipped, no user logged')
    } */
    if (!this.isLogged) {
      try {
        await this.ensureAnonymousLogin()
      } catch(e) {
        // nada
      }
    }
    // ora so di essere in qualche modo loggato (se era possibile farlo)
    if (this.isFullLogged) {
      // se lo sono come utente registrato gestisco in maniera più elaborata...
      this._getEtickets().then(tickets => {
        this.dwReplaceUserTickets(tickets)
        this.$nextTick(() => {
          this.internalBus.$emit('updateEticketVadValidations', this.dwMyTickets.filter(eticket => !eticket.userCode).map(eticket => eticket.id))
        })
      }).catch(err => {
        console.warn(err)
        this.internalBus.$emit('notify:warn', {
          text: this.dictValue('CantUpdateETickets') + (err.status === 418 ? '[VAD]' : ''),
          key: this.notifierKey
        })
      })
    } else if (this.isLogged) {
      // ...altrimenti mi limito a tentare di validare tutto
      this.internalBus.$emit('updateEticketVadValidations', this.dwMyTickets.map(eticket => eticket.id))
    } else {
      console.log('Validations update skipped, no user logged')
    }
    // Ora tento di validare i biglietti usati in passato mentre non avevo rete
    if (this.isLogged) {
      this.dwUserValidatedTicketsTemp.slice().forEach(async el => {
        try {
          await this._userValidateEticket(el.id, el.value)
          this.dwRemovePendingUserValidation(el.id)
        } catch (e) {
          console.warn(e)
        }
      })
    } else {
      console.log('Retarded validation skipped, no user logged')
    }
    /* console.log(window.lastGoingBack)
    if (window.lastGoingBack) {
      let h = localStorage.getItem('mytickets_scroll')
      if (h) {
        console.log(h, typeof h)
        let page = document.querySelector('.page header + div, .page div.noheader')
        page.scrollY = h
      }
    } */
    setTimeout(() => {
      // console.log(window.previousRoute)
      if (window.previousRoute && window.previousRoute.params && window.previousRoute.params.myTicketId) {
        let ticket = document.querySelector('li[tid="' + window.previousRoute.params.myTicketId + '"]')
        if (ticket) {
          console.log('scroll')
          ticket.scrollIntoView()
        } else {
          console.warn('no eticket' + window.previousRoute.params.myTicketId)
        }
      }
    }, 10)
  },
  beforeDestroy () {
    clearTimeout(this.deletingTimeout)
  },
  watch: {
    async isConnected (newV, oldV) {
      if (newV && !oldV) {
        if (!this.isLogged) {
          try {
            await this.ensureAnonymousLogin()
            this.internalBus.$emit('updateEticketVadValidations', this.dwMyTickets.map(eticket => eticket.id))
          } catch(e) {
            // nada
          }
        }
      }
    },
    deleting (newV) {
      if (newV !== null) {
        clearTimeout(this.deletingTimeout)
        this.deletingTimeout = setTimeout(() => {
          this.deleting = null
        }, 2500)
      } else {
        clearTimeout(this.deletingTimeout)
      }
    },
    filters: {
      deep: true,
      handler (newV) {
        localStorage.setItem('my_tickets_filter', JSON.stringify(newV))
      }
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/_vars.scss';

#app.desktop .filters {
  li {
    min-width: 10rem;
    flex: 0 1 auto;

    button {
      display: initial;
      background: transparent;
      // background: rgba(red, 0.4);
      border: none;
      color: var(--white);
      margin: 0;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 100;
      height: 100%;
    }

    button + span {
      padding-left: 1.8rem;
    }
  }
}

.filters {
  list-style: none;
  display: flex;
  flex-direction: row;
  justify-content: stretch;
  flex-wrap: wrap;
  // padding: .3rem;

  li {
    // display: inline-block;
    position: relative;
    flex: 1 1 auto;
    text-align: center;
    margin: 0 0 .3rem .3rem;
    cursor: pointer;
    // background: var(--primary);
    // color: var(--white);

    button {
      display: none;
    }

    span {
      display: block;
      position: relative;
      flex: 1 1 auto;
      text-align: center;
      padding: .5rem .3rem;
      background: var(--primary);
      color: var(--white);
      z-index: 2;
      pointer-events: none;
    }

    select, input {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
      opacity: 0.001;
      z-index: 1;
    }
  }
}

.my-tickets {
  .fa-check {
    color: var(--green);
  }
}

.my-tickets .double-check {
  color: grey;
  text-shadow: 1px .0rem 0 var(--white), .3rem .0rem 0 lightgray;

  &.first-check {
    color: var(--green);
  }
  &.second-check {
    text-shadow: 1px .0rem 0 var(--white), .3rem .0rem 1px var(--green);
  }
}

</style>
